import { NgModule } from '@angular/core';
import { MatButtonModule, MatFormFieldModule, MatMenuModule, MatSelectModule, MatSlideToggleModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { GaugeChartModule } from '@core/components/charts/gauge/gauge.module';
import { StackedVerticalBarModule } from '@core/components/charts/stacked-vertical-bar/stacked-vertical-bar.module';
import { DataCardModule } from '@core/components/data-card/data-card.module';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcCompaniesInputModule } from '@core/components/fc-input/search-many/fc-companies-input/fc-companies-input.module';
import { FcLocationGroupsInputModule } from '@core/components/fc-input/search-many/fc-location-groups-input/fc-location-groups-input.module';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcSegmentsInputModule } from '@core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { FcFilterTypeOutlinedSelectModule } from '@core/components/fc-select/search-one/fc-filter-type-outlined-select/fc-filter-type-outlined-select.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DeadlinesComponent } from './deadlines.component';
import { FilterComponent } from './filter/filter.component';
import { DeadlinesApi } from './services/api/deadlines-api.service';
import { DeadlinesMapperService } from './services/deadlines.mapper.service';
import { DeadlinesResolverService } from './services/deadlines.resolver.service';

const routes: Routes = [
  {
    path: 'relatorios/prazos',
    component: DeadlinesComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.REPORTS.DEADLINES' }
  }
];

@NgModule({
  declarations: [
    DeadlinesComponent,
    FilterComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    StackedVerticalBarModule,

    FcDateInputModule,
    FcSegmentsInputModule,
    FcLocationsInputModule,
    FcCompaniesInputModule,
    FcLocationGroupsInputModule,
    FcMaintenanceTypesInputModule,
    FcFilterTypeOutlinedSelectModule,

    DataCardModule,
    GaugeChartModule,

    MatFormFieldModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule
  ],
  exports: [
    DeadlinesComponent
  ],
  providers: [
    DeadlinesResolverService,
    DeadlinesMapperService,
    DeadlinesApi,
  ]
})

export class DeadlinesModule { }
